var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isChristmas)?_c('logo-christmas',{attrs:{"centered":_vm.centered,"label":_vm.label}}):(_vm.isEaster)?_c('logo-easter',{attrs:{"centered":_vm.centered,"label":_vm.label}}):_c('logo-standard',{attrs:{"centered":_vm.centered,"label":_vm.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }